import React, { useState } from 'react';
import { Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import moment, { isDate } from 'moment'
import axios from 'axios'

const PrintOptionModal = (props) => {
  const [date, setDate] = React.useState(new Date())
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = React.useState(false)
  const [printMode, setPrintMode] = React.useState(props.defaultPrintMode || 'routeSheet')

  React.useEffect(() => {
    if (props.defaultSelectAll && props.crews?.length) {
      setSelected(props.crews.map((crew) => crew._id))
    }
  }, [props.defaultSelectAll, props.crews])

  const handleSelect = (id) => {
      if (selected.includes(id)) {
          setSelected((prev) => prev.filter((i) => i !== id));
      } else {
          setSelected((prev) => [...prev, id]);
      }
  };

  const handleSelectAll = () => {
      if (selected.length === props.crews.length) {
          setSelected([]);
      } else {
          setSelected(props.crews.map((crew) => crew._id));
      }
  };

  const handleClose = () => {
    props.closeModal()
  }

  const handleUpdateDate = (e) => {
    setDate(e.target.value)
  }

  const handlePrint = () => {
    setLoading(true)
    // console.log('Print it:', date)
    let data = {
      date: date,
      mode: printMode
    }
    data[props.selectionField || 'crews'] = selected
    let url = props.printUrl || `${props.url}/api/mtcRoutes/printRouteSheet`
    if (props.isHMI) url = `${props.url}/api/hmi/printRouteSheet`
    axios.post(url, data).then(response => {
      setLoading(false)
      console.log('Print Response', response.data)
      // Return this to the parent as its our PDF
      props.handleShowPDF(response.data)
      if (props.closeOnPrint) props.closeModal()
    }).catch(e => {
      console.log('Error printing: ', e)
      setLoading(false)
      if (props.onError) props.onError(e)
    })
  }


  return (
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>{props.title || 'Route Print'}</DialogTitle>
        <DialogContent style={{ margin: 10, paddingVertical: 15 }}>
          {props.showPrintMode ? (
            <FormControl component="fieldset" style={{ margin: '5px 15px 15px' }}>
              <RadioGroup value={printMode} onChange={(e) => setPrintMode(e.target.value)}>
                <FormControlLabel value="routeSheet" control={<Radio color="primary" />} label="One-day route sheet" />
                <FormControlLabel value="twoWeekAgenda" control={<Radio color="primary" />} label="Two-week crew agenda" />
              </RadioGroup>
            </FormControl>
          ) : null}
          <div style={{ fontSize: '18px', color: '#aaa', margin: '15px' }}>
            {printMode === 'twoWeekAgenda' ? "Choose the week you'd like to start with:" : "Choose Which Day You'd Like to Print:"}
          </div>
          <div  style={{ fontSize: '18px', color: '#aaa', margin: '15px' }}>
            { date ? moment(date).format('dddd, MMMM Do YYYY') : ''}
          </div>
          <DateChooser date={date} changeDate={handleUpdateDate}/>         
          <CrewOptions crews={props.crews} selected={selected} handleSelectAll={handleSelectAll} handleSelect={handleSelect} optionsTitle={props.optionsTitle} optionLabel={props.optionLabel} />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handlePrint} disabled={loading}>
            {
              loading ? <CircularProgress color="primary" size={48} /> : 'PRINT'
            }
          </Button>
          
        
      </DialogActions>
      </Dialog>
  );
};

const CrewOptions = ({ selected, crews, handleSelectAll, handleSelect, optionsTitle, optionLabel }) => {

  return (
    <div style={{  maxHeight: '300px', overflowY: 'scroll', marginTop: 20 }}>
       <div style={{ fontSize: '18px', color: '#aaa' }}>{optionsTitle || 'Choose Which Crews Should Be Included in Your PDF:'}</div>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox
                            checked={selected.length === crews.length}
                            onChange={handleSelectAll}
                        />
                    </TableCell>
                    <TableCell>{optionsTitle ? 'Name (SELECT ALL)' : 'Crew Name (SELECT ALL)'}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {crews.map((crew) => (
                    <TableRow key={crew._id}  onClick={() => handleSelect(crew._id)} style={{ cursor: 'pointer' }}>
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={selected.includes(crew._id)}
                                // onChange={() => handleSelect(crew._id)}
                            />
                        </TableCell>
                       
                        <TableCell>{optionLabel ? optionLabel(crew) : `${crew.number ? `Crew #${crew.number}` : ''} ${crew.name} ${crew.foremanName ? `(${crew.foremanName})` : '' }`}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div>
  )
}

const DateChooser = ({ date, changeDate }) => {

  return (
    <TextField
      id="date"
      label="Date"
      type="date"
      fullWidth
      value={moment(date).format('YYYY-MM-DD') }
      onChange={ changeDate }
      InputLabelProps={{
        shrink: true,
      }}
    />
  )
}

export default PrintOptionModal;
